// extracted by mini-css-extract-plugin
module.exports = {"bg":"WipeOverlay-module--bg--hmLad","black":"WipeOverlay-module--black--xmsRE","red":"WipeOverlay-module--red--NKfFH","grey":"WipeOverlay-module--grey--21frS"};